import {connect} from "react-redux"
import {createSelector} from "reselect"
import State from "../../models/State"
import {isFilterFacet, isPriceFilter} from "../../models/Filter/typeGuards"
import {getFilteredFacetList, isFilteredPriceFn} from "../../utils/getFilterFacets"

const selectFilters = (state: State) => state.search.filters
const selectFacets = (state: State) => state.search.facets
const selectText = (state: State) => state.text
const selectTemplate = (state: State) => state.template

const makeSelectFilteredFacets = createSelector([selectFilters, selectFacets], (filters, facets) => {
    const filteredFacets: Record<string, string[]> = {}
    let isFilteredPrice

    Object.entries(filters).forEach(([_key, value]) => {
        if (isPriceFilter(value)) isFilteredPrice = isFilteredPriceFn(value)
        if (isFilterFacet(value)) {
            const filteredFacetList = getFilteredFacetList(value, facets)
            if (filteredFacetList.length > 0) filteredFacets[value.displayName] = filteredFacetList
        }
    })

    return {filteredFacets, isFilteredPrice}
})

export const mapStateToProps = (state: State) => {
    const {filteredFacets, isFilteredPrice} = makeSelectFilteredFacets(state)

    return {
        isFilterSelected: Object.keys(filteredFacets).length > 0,
        isFilteredPrice,
        filteredFacets,
        text: selectText(state),
        templating: selectTemplate(state),
    }
}

export default connect(mapStateToProps)
